
export const reviews = [
  {
    id: 1,
    content: "Delivery and pickup was seamless. Definitely using Skipti in the future.",
    customerName: "Melissa R.",
    rate: 5,
  },
  {
    id: 2,
    content: "Great Experience! Fantastic customer service. Recommending to friends this very moment.",
    customerName: "Christopher F.",
    rate: 5,
  },
  {
    id: 3,
    content: "Delivery was on time and easy. The rental was in great condition and a lot of fun to use. I am going to do this again and again for sure.",
    customerName: "Frank H.",
    rate: 5,
  },
  {
    id: 4,
    content: "Very convenient. I would do it again or recommend to others.",
    customerName: "Mike B.",
    rate: 5,
  },
  {
    id: 5,
    content: "Great service, easy pickup.",
    customerName: "Kenny H.",
    rate: 5,
  }
];
